import React from "react";
import { usePreventionsByMonthQuery } from "../../redux/slices/chart";
import { Line } from "react-chartjs-2";
import {
  Chart,
  CategoryScale,
  LinearScale,
  LineElement,
  PointElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from "chart.js";

// Register the required components
Chart.register(
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  LineElement,
  PointElement,
  Legend,
  Filler
);

interface PropsTypes {
  selectedYear: string | null;
  selectedCity: any | null;
}

const PreventionByMonth = ({ selectedYear, selectedCity }: PropsTypes) => {
  const { data, isLoading } = usePreventionsByMonthQuery({
    year: selectedYear,
    city: selectedCity,
  });

  const chartData = {
    labels: data?.labels,
    datasets: [
      {
        label: "Preventions By Month",
        data: data?.values, // Corresponding values
        backgroundColor: "rgba(54, 162, 235, 0.2)", // Light blue fill
        borderColor: "rgba(54, 162, 235, 1)",       // Stronger blue line
        pointBackgroundColor: "rgba(54, 162, 235, 1)",
        pointBorderColor: "#fff",
        borderWidth: 1,
        fill: true,
        tension: 0.5,
      },
    ],
  };

  return (
    <div>
      {isLoading ? (
        <p>Loading...</p>
      ) : chartData ? (
        <Line
          data={chartData}
          options={{
            responsive: true,
            plugins: {
              legend: { position: "top" },
              title: {
                display: true,
                // text: `Evictions By Month`,
              },
            },
          }}
        />
      ) : (
        "No Data Found"
      )}
    </div>
  );
};

export default PreventionByMonth;